import { atom } from "recoil";
import { ToastData } from "../../types/ui";

export const toastDataAtom = atom<ToastData[]>({
  key: "toastDataAtom",
  default: [],
});

export const isInDemoMode = atom<boolean>({
  key: "isInDemoMode",
  default: false,
});

export const allPlansLocked = atom<boolean>({
  key: "allPlansLocked",
  default: true,
});
